import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { TipoLancamentoConfiguracao } from '../../../models/tipo-lancamento-configuracao';
import { MesclarTiposRetorno } from '../../../models/mesclar-tipos-retorno';
import { ConfiguracaoCaixaApiService } from '../../../services/configuracao-caixa-api.service';
import { MessageService } from '@services/message.service';

@Component({
  selector: 'app-mesclar-tipos-dialog',
  standalone: false,
  templateUrl: './mesclar-tipos-dialog.component.html',
  styleUrl: './mesclar-tipos-dialog.component.scss'
})
export class MesclarTiposDialogComponent {

  title: string = 'Mesclar Tipos';
  tipos: TipoLancamentoConfiguracao[] = [];
  tipoAtual?: TipoLancamentoConfiguracao;
  tipoSelecionado?: TipoLancamentoConfiguracao;
  nomeFinal: string = '';

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<MesclarTiposDialogComponent>
  ) { }

  public onSelectionChange(): void {
    this.nomeFinal = this.tipoSelecionado?.nome ?? '';
  }

  public salvarClick(): void {
    if (!this.tipoSelecionado) {
      this.messageService.showToastWarning('Selecione um tipo destino para a mesclagem');
      return;
    }
    if (this.tipoSelecionado.id === this.tipoAtual?.id) {
      this.messageService.showToastWarning('O tipo selecionado é o mesmo que o tipo que será mesclado');
      return;
    }
    if (!this.nomeFinal?.trim()) {
      this.messageService.showToastWarning('O nome do tipo não pode ser vazio');
      return;
    }

    const retorno: MesclarTiposRetorno = {
      tipoOrigemId: this.tipoAtual!.id,
      tipoDestinoId: this.tipoSelecionado!.id,
      nomeFinal: this.nomeFinal
    };

    this.configuracaoCaixaApiService.mesclarTipos(retorno).subscribe(() => {
      this.messageService.showToastSuccess('Salvo com sucesso');
      this.dialogRef.close(true);
    });
  }
}
